import { DOCUMENT, NgIf } from '@angular/common';
import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CallbackDomainResponse } from '../../../core/models/CallbackDomainResponse';
import { GtOAuthService } from '../../../core/services/gt-oauth.service';
import { LoginService } from '../../../core/services/login.service';
import { UtilsService } from '../../../core/services/utils';
import { GtAppLoaderComponent } from '../../../core/components/gt-app-loader/gt-app-loader.component';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    imports: [NgIf, NgbAlert, GtAppLoaderComponent]
})
export class CallbackComponent implements OnInit {
  public errorMsg: string;
  public processing: boolean;
  private queryObj: any;
  private domainName: string;
  private queryString: string;
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute,
              private router: Router,
              private loginService: LoginService,
              private utilsService: UtilsService,
              private gtOauthService: GtOAuthService,
              @Inject(DOCUMENT) private document: any) {
    this.domainSubscriber = this.domainSubscriber.bind(this);
    this.domainErrorSubscriber = this.domainErrorSubscriber.bind(this);
  }

  public ngOnInit() {
    this.route.fragment
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.queryString = params;
        if (params) {
          this.queryObj = this.utilsService.parseUrlString(params);
          if (this.queryObj.error) {
            this.errorMsg = this.queryObj.error_description;
            this.gtOauthService.forceFullyInitiateOauthFlow();
          } else {
            this.processing = true;
            const token = this.queryObj.access_token;
            this.getDomain(token);
          }
        }
      });
  }

  private getDomain(token: string) {
    this.loginService.initiateCallback(token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.domainSubscriber, this.domainErrorSubscriber);
  }

  private domainSubscriber(res: CallbackDomainResponse) {
    this.processing = false;
    const context = {domain: res.domain, queryString: this.queryString};
    this.domainName = this.utilsService.parseTemplateString(environment.callbackTemplate, context);
    const redirectUrl =  (this.domainName + '&targetUrl=' + res.targetUrl);
    this.document.location.href = redirectUrl;
  }

  private domainErrorSubscriber(res: any) {
    this.processing = false;
    console.error( res.error.message);
    this.errorMsg = res.error.message;
  }
}
